import React, {Component} from 'react';
import './Header.css';
import 'react-typist/dist/Typist.css';
import Typist from 'react-typist';


class Header extends Component {

render(){
return(
    <div className='header'>
      <h1 className='name-header'>Akil M Hylton</h1>
      <h2 className='title-header'>
        <Typist avgTypingSpeed={20} startDelay={1450}>
          ReactJS Developer
          <Typist.Backspace count={18} delay={250}/>
          Front-end Developer
        </Typist>
      </h2>
      <div className='arrowheight'>
        <i className="downArrow bounce material-icons">&#xE313;</i>
      </div>

    </div>
  );
 }
}

export default Header;



// WEBPACK FOOTER //
// ./src/container/Header/Header.js